import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Atoms, Charts } from 'components';
import { getPfamDomain } from 'api/fetch_data';

class GenePfamDomain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            plotData: []
        };
        this.header = [
            { key: 'PfamId', content: 'Pfam' },
            { key: 'PfamType', content: 'Pfam type' },
            { key: 'PfamName', content: 'Name' },
            { key: 'chrom', content: 'Chrom' },
            { key: 'start', content: 'Start' },
            { key: 'end', content: 'End' },
            { key: 'strand', content: 'Strand' },
            { key: 'search', content: 'Search same domain gene' }
        ];
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount() {
        this.__ignoreLastFetch = true;
    }

    fetchData = () => {
        const { genomeAbbr, id } = this.props;
        getPfamDomain(genomeAbbr, id, "Locus").then(data => {
            if (!this.__ignoreLastFetch) {
                const dataSource = data.map(item => ({
                    PfamId: <a href={`http://pfam.xfam.org/family/${item['PfamId']}`}>{item['PfamId']}</a>,
                    PfamType: item['PfamType'],
                    PfamName: item['PfamName'],
                    chrom: item['chrom'],
                    start: item['start'],
                    end: item['end'],
                    strand: item['strand'],
                    search: <Link to={{
                        pathname: '/search/pfam_domain',
                        state: {'searchText': item['PfamId'], "species": "All", "genome": "All", "assemble": "All"}
                    }}>Search</Link>
                }));
                const plotData = data.map(item => ({
                    group: item['PfamType'],
                    start: item['start'],
                    end: item['end'],
                    strand: item['strand'],
                    name: item['PfamName'],
                    blocks: item['blocks'],
                }));
                this.setState({dataSource, plotData});
            }
        });
        
    };

    render() {
        const {locus} = this.props;
        const { dataSource, plotData } = this.state;

        if (dataSource.length === 0){
            return null;
        }
        return (
            <Atoms.ExpansionInfoCard
                title="Pfam domain"
                mainContent={
                    <Charts.GeneStructure
                        bpStart={locus.start}
                        bpEnd={locus.end}
                        heightPerDataGroup={20}
                        width={1000}
                        padding={[10, 50, 30, 150]}
                        dataSource={plotData}
                    />
                }
                expansionContent={
                    <Atoms.CustomTable 
                        columns={this.header} 
                        dataSource={dataSource} />
                }
            />
        );
    }
}

GenePfamDomain.propTypes = {
    locus: PropTypes.object,
    genomeAbbr: PropTypes.string,
    speciesAbbr: PropTypes.string,
    id: PropTypes.string,
};

export default GenePfamDomain;

